/*
 * @Author: Nanxing Xiang
 * @Date: 2021-03-10 17:14:16
 * @LastEditors: Nanxing Xiang
 * @LastEditTime: 2021-05-08 17:09:54
 * @Description: file content
 */
// // export default function throttle<T1>(fn:())
export default function throttle(fn, wait) {
  var pre = Date.now();
  return function () {
    var now = Date.now();
    if (now - pre >= wait) {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      fn.apply(this, args);
      pre = now;
    }
  };
}